import {GetBannerResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/banner/service.types';

const HERO_IMAGE =
  'https://cdn.aboutstatic.com/file/8b52d4f5eccc56d4b0e211d0f04531e0.jpg?quality=75&height=430&width=860';

export const basketBannerMock: GetBannerResponse = {
  banner: {
    variant: {
      $case: 'highlightBanner',
      highlightBanner: {
        headline: 'Free delivery today',
        subline: 'Order now and get it shipped on us',
        colors: {
          foregroundColor: {hex: '#FFFFFF'},
          backgroundColor: {hex: '#0E7490'},
        },
        gradientColors: ['#22D3EE', 'rgba(34, 211, 238, 0)'],
        media: {
          backgroundColor: '#0E7490',
          variant: {
            $case: 'image',
            image: {
              url: HERO_IMAGE,
              description: 'Banner hero',
              external: false,
            },
          },
        },
        cta: {
          label: 'Continue',
          colors: {
            foregroundColor: {hex: '#0E7490'},
            backgroundColor: {hex: '#FFFFFF'},
          },
        },
        infoIcon: {
          headline: 'About free delivery',
          content: {
            text: 'Free delivery applies automatically to all orders today.',
          },
        },
        productImages: [],
        isAd: false,
        tracker: {
          promotionId: 'mock-basket-banner',
          promotionName: 'Mock Basket Banner',
          creativeName: 'highlight',
          creativeSlot: 'basket-header',
        },
      },
    },
  },
};
